import { render, staticRenderFns } from "./ProfileCompletionReport.vue?vue&type=template&id=b121cb6a&"
import script from "./ProfileCompletionReport.vue?vue&type=script&lang=js&"
export * from "./ProfileCompletionReport.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCompletionReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports